export let config = {

  pixelRatio: {
    targetFps: 40,
    step: 0.25,
    auto: false,
    start: 1,
    // start: 2, // DEBUG DESKTOP
    min: 0.5,
    max: 2
  },

  skipEnterButton: false,
  skipIntro: false,
  skipResults: false,
  skipToStage2: false,
  skipToSlowWorld: false,
  skipToSpeedWorld: false,

  controlsMultiplier: 3.5,
  // controlsMultiplier: 15, // DEBUG DESKTOP

  uiUpdateInterval: 34,
  worldScale: 1,
  introScale: 10,

  velocityMin: 3,
  // velocityMax: 100,
  velocityMax: 100,
  velocityOffset: 5,
  swipeAddVelocity: 0.06,
  maxBaseVelocity: 12,

  numRunners: 8,
  maxRunnerOffset: 2,
  runnerOffset: 1.25,
  cpuVel: {
    min: 12,
    max: 50
  },

  introDistance: 0.997,
  startDistance: 0.997,

  totalPx: 3000000,
  numLaps: 1,

  helpModeAvailable: true,
  helpTime: 3000, // Duration of inactivity to trigger help

  stage0Length: 0.10,
  stage1Length: 0.37, // Percentage length of stage 1
  stage2Length: 0.388, // Percentage length of stage 2

  stage1RankLimit: 5,
  breakScale: 1.001 // Percentage faster to break

}
const initialConfig = Object.assign({}, config)

export const reset = function (delta) {
  config = Object.assign({}, initialConfig)
  config.reset = reset
}
config.reset = reset


export default config





// WEBPACK FOOTER //
// ./src/components/game/config.js